"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// *** Version: 12 ***

function communLeatherGoodsFinish(slug) {
  return {
    name: 'Finition',
    slug: 'finish',
    items: [{
      name: 'Recollage (x1)',
      prices: {
        SIMPLE: 5,
        COMPLEX: 5
      },
      id: "12.".concat(slug, "-finish-1"),
      hidden: true
    }, {
      name: 'Finition supplémentaire - Simple',
      prices: {
        SIMPLE: 5,
        COMPLEX: 5
      },
      id: "12.".concat(slug, "-finish-2")
    }, {
      name: 'Finition supplémentaire - Standard',
      prices: {
        SIMPLE: 10,
        COMPLEX: 10
      },
      id: "12.".concat(slug, "-finish-3")
    }, {
      name: 'Finition supplémentaire - Complexe',
      prices: {
        SIMPLE: 20,
        COMPLEX: 20
      },
      id: "12.".concat(slug, "-finish-4")
    }, {
      name: 'Finition supplémentaire - Luxe',
      prices: {
        SIMPLE: 50,
        COMPLEX: 50
      },
      id: "12.".concat(slug, "-finish-5")
    }, {
      name: 'Ajustement sur-mesure (1h)',
      prices: {
        SIMPLE: 80,
        COMPLEX: 80
      },
      id: "12.".concat(slug, "-finish-6")
    }]
  };
}
function generateLeatherGoodsAccePrice(slug) {
  return {
    categories: [{
      name: 'Entretenir',
      slug: 'prevent',
      items: [{
        name: 'Nettoyage & Soin complet',
        prices: {
          SIMPLE: 25,
          COMPLEX: 30
        },
        id: "12.".concat(slug, "-prevent-1")
      }, {
        name: 'Cirage simple',
        prices: {
          SIMPLE: 15,
          COMPLEX: 15
        },
        id: "12.".concat(slug, "-prevent-2")
      }, {
        name: 'Imperméabiliser',
        prices: {
          SIMPLE: 20,
          COMPLEX: 20
        },
        id: "12.".concat(slug, "-prevent-3")
      }, {
        name: 'Perçage de trou',
        prices: {
          SIMPLE: 3,
          COMPLEX: 3
        },
        id: "12.".concat(slug, "-prevent-4")
      }, {
        name: 'Nettoyage - Bijouterie / pièces métalliques',
        prices: {
          SIMPLE: 30,
          COMPLEX: 30
        },
        id: "12.".concat(slug, "-prevent-5")
      }]
    }, {
      name: 'Recolorer',
      slug: 'recolor',
      items: [{
        name: 'Rénovation standard - Petite maroquinerie',
        prices: {
          SIMPLE: 60,
          COMPLEX: 60
        },
        id: "12.".concat(slug, "-recolor-1")
      }, {
        name: 'Rénovation complexe - Petite maroquinerie',
        prices: {
          SIMPLE: 60,
          COMPLEX: 60
        },
        id: "12.".concat(slug, "-recolor-2")
      }]
    }, {
      name: 'Réparer',
      slug: 'cure',
      items: [{
        name: 'Zip - Changement simple',
        prices: {
          SIMPLE: 80,
          COMPLEX: 80
        },
        multiple: true,
        id: "12.".concat(slug, "-cure-1")
      }, {
        name: 'Zip - Changement simple fourni par le client',
        prices: {
          SIMPLE: 50,
          COMPLEX: 50
        },
        multiple: true,
        id: "12.".concat(slug, "-cure-2")
      }, {
        name: 'Zip - Changement standard',
        prices: {
          SIMPLE: 100,
          COMPLEX: 100
        },
        multiple: true,
        id: "12.".concat(slug, "-cure-3")
      }, {
        name: 'Zip - Changement standard fourni par le client',
        prices: {
          SIMPLE: 70,
          COMPLEX: 70
        },
        multiple: true,
        id: "12.".concat(slug, "-cure-4")
      }, {
        name: 'Zip - Changement complexe',
        prices: {
          SIMPLE: 150,
          COMPLEX: 150
        },
        multiple: true,
        id: "12.".concat(slug, "-cure-5")
      }, {
        name: 'Zip - Changement complexe fourni par le client',
        prices: {
          SIMPLE: 90,
          COMPLEX: 90
        },
        multiple: true,
        id: "12.".concat(slug, "-cure-6")
      }, {
        name: 'Curseur',
        prices: {
          SIMPLE: 15,
          COMPLEX: 15
        },
        id: "12.".concat(slug, "-cure-7")
      }, {
        name: 'Curseur fourni par le client',
        prices: {
          SIMPLE: 13,
          COMPLEX: 13
        },
        id: "12.".concat(slug, "-cure-8")
      }, {
        name: 'Tirette de curseur',
        prices: {
          SIMPLE: 5,
          COMPLEX: 5
        },
        id: "12.".concat(slug, "-cure-9")
      }, {
        name: 'Tirette de curseur fourni par le client',
        prices: {
          SIMPLE: 4,
          COMPLEX: 4
        },
        id: "12.".concat(slug, "-cure-10")
      }, {
        name: 'Boutons pression / rivet / oeillet (<10)',
        prices: {
          SIMPLE: 3,
          COMPLEX: 3
        },
        multiple: true,
        id: "12.".concat(slug, "-cure-11")
      }, {
        name: 'Boutons pression / rivet / oeillet (<10) fourni par le client',
        prices: {
          SIMPLE: 2,
          COMPLEX: 2
        },
        multiple: true,
        id: "12.".concat(slug, "-cure-12")
      }, {
        name: 'Boutons pression / rivet / oeillet (>10)',
        prices: {
          SIMPLE: 25,
          COMPLEX: 25
        },
        multiple: true,
        id: "12.".concat(slug, "-cure-22")
      }, {
        name: 'Fermoir - Changement simple',
        prices: {
          SIMPLE: 40,
          COMPLEX: 40
        },
        id: "12.".concat(slug, "-cure-13")
      }, {
        name: 'Fermoir - Changement simple fourni par le client',
        prices: {
          SIMPLE: 30,
          COMPLEX: 30
        },
        id: "12.".concat(slug, "-cure-14")
      }, {
        name: 'Fermoir - Changement complexe',
        prices: {
          SIMPLE: 60,
          COMPLEX: 60
        },
        id: "12.".concat(slug, "-cure-15")
      }, {
        name: 'Fermoir - Changement complexe fourni par le client',
        prices: {
          SIMPLE: 50,
          COMPLEX: 50
        },
        id: "12.".concat(slug, "-cure-16")
      }, {
        name: 'Crochet / boucle / autre pièce métallique - Changement',
        prices: {
          SIMPLE: 30,
          COMPLEX: 30
        },
        id: "12.".concat(slug, "-cure-17")
      }, {
        name: 'Crochet / boucle / autre pièce métallique fourni par le client - Changement',
        prices: {
          SIMPLE: 20,
          COMPLEX: 20
        },
        id: "12.".concat(slug, "-cure-18")
      }, {
        name: 'Doublure - Changement',
        prices: {
          SIMPLE: 60,
          COMPLEX: 60
        },
        id: "12.".concat(slug, "-cure-20")
      }, {
        name: 'Craquelure / éraflure',
        prices: {
          SIMPLE: 10,
          COMPLEX: 10
        },
        id: "12.".concat(slug, "-cure-23")
      }, {
        name: 'Déchirure - Petite (0 à 10 cm)',
        prices: {
          SIMPLE: 15,
          COMPLEX: 15
        },
        multiple: true,
        id: "12.".concat(slug, "-cure-24")
      }, {
        name: 'Déchirure - Moyenne (10 à 20 cm)',
        prices: {
          SIMPLE: 20,
          COMPLEX: 20
        },
        multiple: true,
        id: "12.".concat(slug, "-cure-25")
      }, {
        name: 'Trou (1 à 2 cm)',
        prices: {
          SIMPLE: 40,
          COMPLEX: 40
        },
        multiple: true,
        id: "12.".concat(slug, "-cure-26")
      }, {
        name: 'Coins abîmés (x4)',
        prices: {
          SIMPLE: 40,
          COMPLEX: 40
        },
        id: "12.".concat(slug, "-cure-27")
      }, {
        name: 'Couture décousue (0 à 5 cm)',
        prices: {
          SIMPLE: 15,
          COMPLEX: 15
        },
        id: "12.".concat(slug, "-cure-28")
      }, {
        name: 'Couture décousue (5 à 10 cm)',
        prices: {
          SIMPLE: 20,
          COMPLEX: 20
        },
        id: "12.".concat(slug, "-cure-29")
      }, {
        name: 'Couture décousue (10 à 40 cm)',
        prices: {
          SIMPLE: 30,
          COMPLEX: 30
        },
        id: "12.".concat(slug, "-cure-30")
      }, {
        name: 'Couture décousue (> 40 cm)',
        prices: {
          SIMPLE: 60,
          COMPLEX: 60
        },
        id: "12.".concat(slug, "-cure-31")
      }, {
        name: 'Couture main / sellier',
        prices: {
          SIMPLE: 60,
          COMPLEX: 60
        },
        id: "12.".concat(slug, "-cure-32")
      }, {
        name: 'Ceinture - Changement intégral',
        prices: {
          SIMPLE: 120,
          COMPLEX: 120
        },
        id: "12.".concat(slug, "-cure-33")
      }, {
        name: 'Déchirure : réparation avec pose d‘empiècement',
        prices: {
          SIMPLE: 60
        },
        multiple: true,
        id: "12.".concat(slug, "-cure-19"),
        hidden: true
      }, {
        name: 'Bandoulière / anse / poignée / biais - Changement simple (x1)',
        prices: {
          SIMPLE: 40
        },
        id: "12.".concat(slug, "-cure-21"),
        hidden: true
      }]
    }, communLeatherGoodsFinish(slug)]
  };
}

/* eslint max-len: 0, object-curly-newline: 0 */

/** @param { import("../entities/types").RawPricingPiece } rawLeatherGoodsPricing */
var rawLeatherGoodsPricing = [{
  name: 'Sac',
  slug: 'bag',
  hasMostCommonCategory: false,
  types: [{
    slug: 'SIMPLE',
    name: 'Cuir'
  }, {
    slug: 'COMPLEX',
    name: 'Daim'
  }],
  categories: [{
    name: 'Prise en charge',
    slug: 'receiving',
    items: [{
      name: 'Prise en charge - Petit sac (< 25 cm)',
      prices: {
        SIMPLE: 0,
        COMPLEX: 0
      },
      id: '12.bag-receiving-1'
    }, {
      name: 'Prise en charge - Sac moyen / tote bag (25-40 cm)',
      prices: {
        SIMPLE: 0,
        COMPLEX: 0
      },
      id: '12.bag-receiving-2'
    }, {
      name: 'Prise en charge - Grand sac / sac de voyage (50 cm max)',
      prices: {
        SIMPLE: 0,
        COMPLEX: 0
      },
      id: '12.bag-receiving-3'
    }]
  }, {
    name: 'Entretenir',
    slug: 'prevent',
    items: [{
      name: 'Nettoyage & Soin complet - Petit sac (< 25 cm)',
      prices: {
        SIMPLE: 50,
        COMPLEX: 60
      },
      id: '12.bag-prevent-1'
    }, {
      name: 'Nettoyage & Soin complet - Sac moyen / tote bag (25-40 cm)',
      prices: {
        SIMPLE: 70,
        COMPLEX: 90
      },
      id: '12.bag-prevent-2'
    }, {
      name: 'Nettoyage & Soin complet - Grand sac / sac de voyage (50 cm max) ',
      prices: {
        SIMPLE: 90,
        COMPLEX: 150
      },
      id: '12.bag-prevent-3'
    }, {
      name: 'Cirage simple - Petit sac (< 25 cm)',
      prices: {
        SIMPLE: 20,
        COMPLEX: 20
      },
      id: '12.bag-prevent-4'
    }, {
      name: 'Cirage simple - Sac moyen / tote bag (25-40 cm)',
      prices: {
        SIMPLE: 30,
        COMPLEX: 30
      },
      id: '12.bag-prevent-6'
    }, {
      name: 'Cirage simple - Grand sac / sac de voyage (50 cm max)',
      prices: {
        SIMPLE: 50,
        COMPLEX: 50
      },
      id: '12.bag-prevent-7'
    }, {
      name: 'Imperméabiliser',
      prices: {
        SIMPLE: 15,
        COMPLEX: 15
      },
      id: '12.bag-prevent-5'
    }, {
      name: 'Nettoyage - Bijouterie / pièces métalliques',
      prices: {
        SIMPLE: 30,
        COMPLEX: 30
      },
      id: '12.bag-prevent-8'
    }]
  }, {
    name: 'Recolorer',
    slug: 'recolor',
    items: [{
      name: 'Recoloration - Partielle (x1)',
      prices: {
        SIMPLE: 20,
        COMPLEX: 20
      },
      id: '12.bag-recolor-1'
    }, {
      name: 'Rénovation standard - Petit sac (< 25 cm)',
      prices: {
        SIMPLE: 90,
        COMPLEX: 90
      },
      id: '12.bag-recolor-11'
    }, {
      name: 'Rénovation standard - Sac moyen / tote bag (25-40 cm)',
      prices: {
        SIMPLE: 110,
        COMPLEX: 110
      },
      id: '12.bag-recolor-12'
    }, {
      name: 'Rénovation standard - Grand sac / sac de voyage (50 cm max)',
      prices: {
        SIMPLE: 150,
        COMPLEX: 150
      },
      id: '12.bag-recolor-13'
    }, {
      name: 'Rénovation complexe - Petit sac (< 25 cm)',
      prices: {
        SIMPLE: 125,
        COMPLEX: 125
      },
      id: '12.bag-recolor-2'
    }, {
      name: 'Rénovation complexe - Sac moyen / tote bag (25-40 cm)',
      prices: {
        SIMPLE: 175,
        COMPLEX: 175
      },
      id: '12.bag-recolor-3'
    }, {
      name: 'Rénovation complexe - Grand sac / sac de voyage (50 cm max)',
      prices: {
        SIMPLE: 225,
        COMPLEX: 225
      },
      id: '12.bag-recolor-4'
    }, {
      name: 'Teinture de tranche - Simple / petit sac',
      prices: {
        SIMPLE: 20,
        COMPLEX: 20
      },
      id: '12.bag-recolor-5'
    }, {
      name: 'Teinture de tranche - Standard / sac moyen',
      prices: {
        SIMPLE: 40,
        COMPLEX: 40
      },
      id: '12.bag-recolor-6'
    }, {
      name: 'Teinture de tranche - Complexe / grand sac',
      prices: {
        SIMPLE: 60,
        COMPLEX: 60
      },
      id: '12.bag-recolor-7'
    }, {
      name: 'Teinture de tranche - Poignées ou anse (x2)',
      prices: {
        SIMPLE: 50,
        COMPLEX: 50
      },
      id: '12.bag-recolor-8'
    }, {
      name: 'Changement de teinte - Petit sac',
      prices: {
        SIMPLE: 155,
        COMPLEX: 155
      },
      id: '12.bag-recolor-9'
    }, {
      name: 'Changement de teinte - Sac moyen',
      prices: {
        SIMPLE: 205,
        COMPLEX: 205
      },
      id: '12.bag-recolor-10'
    }]
  }, {
    name: 'Réparer',
    slug: 'cure',
    items: [{
      name: 'Craquelure / éraflure : raccord couleur',
      prices: {
        SIMPLE: 20,
        COMPLEX: 20
      },
      id: '12.bag-cure-1'
    }, {
      name: 'Craquelure / éraflure',
      prices: {
        SIMPLE: 10,
        COMPLEX: 10
      },
      id: '12.bag-cure-40'
    }, {
      name: 'Déchirure - Petite (0 à 10 cm)',
      prices: {
        SIMPLE: 15,
        COMPLEX: 15
      },
      multiple: true,
      id: '12.bag-cure-41'
    }, {
      name: 'Déchirure - Moyenne (10 à 20 cm)',
      prices: {
        SIMPLE: 20,
        COMPLEX: 20
      },
      multiple: true,
      id: '12.bag-cure-42'
    }, {
      name: 'Trou (1 à 2 cm)',
      prices: {
        SIMPLE: 40,
        COMPLEX: 40
      },
      multiple: true,
      id: '12.bag-cure-43'
    }, {
      name: 'Coins abîmés (x4)',
      prices: {
        SIMPLE: 40,
        COMPLEX: 40
      },
      id: '12.bag-cure-44'
    }, {
      name: 'Biais craquelé / abîmé - Sac petit ou moyen',
      prices: {
        SIMPLE: 40,
        COMPLEX: 40
      },
      id: '12.bag-cure-45'
    }, {
      name: 'Biais craquelé / abîmé - Grand sac',
      prices: {
        SIMPLE: 70,
        COMPLEX: 70
      },
      id: '12.bag-cure-46'
    }, {
      name: 'Couture décousue (0 à 5 cm)',
      prices: {
        SIMPLE: 15,
        COMPLEX: 15
      },
      id: '12.bag-cure-47'
    }, {
      name: 'Couture décousue (5 à 10 cm)',
      prices: {
        SIMPLE: 20,
        COMPLEX: 20
      },
      id: '12.bag-cure-48'
    }, {
      name: 'Couture décousue (10 à 40 cm)',
      prices: {
        SIMPLE: 30,
        COMPLEX: 30
      },
      id: '12.bag-cure-49'
    }, {
      name: 'Couture décousue (> 40 cm)',
      prices: {
        SIMPLE: 60,
        COMPLEX: 60
      },
      id: '12.bag-cure-50'
    }, {
      name: 'Couture main / sellier',
      prices: {
        SIMPLE: 60,
        COMPLEX: 60
      },
      id: '12.bag-cure-51'
    }, {
      name: 'Bandoulière en cuir - Rénovation',
      prices: {
        SIMPLE: 60,
        COMPLEX: 60
      },
      id: '12.bag-cure-52'
    }, {
      name: 'Bandoulière en cuir - Changement intégral (simple)',
      prices: {
        SIMPLE: 120,
        COMPLEX: 120
      },
      id: '12.bag-cure-53'
    }, {
      name: 'Bandoulière en cuir - Changement intégral (double face)',
      prices: {
        SIMPLE: 150,
        COMPLEX: 150
      },
      id: '12.bag-cure-54'
    }, {
      name: 'Bandoulière en toile ou en métal - Changement intégral',
      prices: {
        SIMPLE: 70,
        COMPLEX: 70
      },
      id: '12.bag-cure-55'
    }, {
      name: 'Enchape - Réparation x1',
      prices: {
        SIMPLE: 30,
        COMPLEX: 30
      },
      id: '12.bag-cure-57'
    }, {
      name: 'Anse / poignée - Rénovation (x2)',
      prices: {
        SIMPLE: 70,
        COMPLEX: 70
      },
      id: '12.bag-cure-58'
    }, {
      name: 'Anse / poignée - Changement complet (x2)',
      prices: {
        SIMPLE: 150,
        COMPLEX: 150
      },
      id: '12.bag-cure-59'
    }, {
      name: 'Poignée ronde (couture main) - Rénovation (x2)',
      prices: {
        SIMPLE: 110,
        COMPLEX: 110
      },
      id: '12.bag-cure-60'
    }, {
      name: 'Poignée ronde (couture main) - Changement complet (x2)',
      prices: {
        SIMPLE: 220,
        COMPLEX: 220
      },
      id: '12.bag-cure-61'
    }, {
      name: 'Doublure - Changement partiel',
      prices: {
        SIMPLE: 60,
        COMPLEX: 60
      },
      id: '12.bag-cure-14'
    }, {
      name: 'Doublure - Changement intégral - Simple',
      prices: {
        SIMPLE: 90,
        COMPLEX: 90
      },
      id: '12.bag-cure-15'
    }, {
      name: 'Doublure - Changement intégral - Standard',
      prices: {
        SIMPLE: 140,
        COMPLEX: 135
      },
      id: '12.bag-cure-16'
    }, {
      name: 'Doublure - Changement intégral - Complexe',
      prices: {
        SIMPLE: 180,
        COMPLEX: 180
      },
      id: '12.bag-cure-17'
    }, {
      name: 'Zip - Changement simple',
      prices: {
        SIMPLE: 80,
        COMPLEX: 80
      },
      multiple: true,
      id: '12.bag-cure-21'
    }, {
      name: 'Zip - Changement simple fourni par le client',
      prices: {
        SIMPLE: 50,
        COMPLEX: 50
      },
      multiple: true,
      id: '12.bag-cure-22'
    }, {
      name: 'Zip - Changement standard',
      prices: {
        SIMPLE: 100,
        COMPLEX: 100
      },
      multiple: true,
      id: '12.bag-cure-23'
    }, {
      name: 'Zip - Changement standard fourni par le client',
      prices: {
        SIMPLE: 70,
        COMPLEX: 70
      },
      multiple: true,
      id: '12.bag-cure-24'
    }, {
      name: 'Zip - Changement complexe',
      prices: {
        SIMPLE: 150,
        COMPLEX: 150
      },
      multiple: true,
      id: '12.bag-cure-25'
    }, {
      name: 'Zip - Changement complexe fourni par le client',
      prices: {
        SIMPLE: 90,
        COMPLEX: 90
      },
      multiple: true,
      id: '12.bag-cure-26'
    }, {
      name: 'Curseur',
      prices: {
        SIMPLE: 15,
        COMPLEX: 15
      },
      id: '12.bag-cure-27'
    }, {
      name: 'Curseur fourni par le client',
      prices: {
        SIMPLE: 13,
        COMPLEX: 13
      },
      id: '12.bag-cure-28'
    }, {
      name: 'Tirette de curseur',
      prices: {
        SIMPLE: 5,
        COMPLEX: 5
      },
      id: '12.bag-cure-29'
    }, {
      name: 'Tirette de curseur fourni par le client',
      prices: {
        SIMPLE: 4,
        COMPLEX: 4
      },
      id: '12.bag-cure-30'
    }, {
      name: 'Boutons pression / rivet / oeillet (<10)',
      prices: {
        SIMPLE: 3,
        COMPLEX: 3
      },
      multiple: true,
      id: '12.bag-cure-31'
    }, {
      name: 'Boutons pression / rivet / oeillet (<10) fourni par le client',
      prices: {
        SIMPLE: 2,
        COMPLEX: 2
      },
      multiple: true,
      id: '12.bag-cure-32'
    }, {
      name: 'Boutons pression / rivet / oeillet (>10)',
      prices: {
        SIMPLE: 25,
        COMPLEX: 25
      },
      multiple: true,
      id: '12.bag-cure-62'
    }, {
      name: 'Fermoir - Changement simple (aimant / pression / mousqueton)',
      prices: {
        SIMPLE: 40,
        COMPLEX: 40
      },
      id: '12.bag-cure-33'
    }, {
      name: 'Fermoir - Changement simple (aimant / pression / mousqueton) fourni par le client',
      prices: {
        SIMPLE: 30,
        COMPLEX: 30
      },
      id: '12.bag-cure-34'
    }, {
      name: 'Fermoir - Changement complexe (fermoir tourniquet et autres boucles)',
      prices: {
        SIMPLE: 60,
        COMPLEX: 60
      },
      id: '12.bag-cure-35'
    }, {
      name: 'Fermoir - Changement complexe (fermoir tourniquet et autres boucles) fourni par le client',
      prices: {
        SIMPLE: 50,
        COMPLEX: 50
      },
      id: '12.bag-cure-36'
    }, {
      name: 'Autre pièce métallique (crochet / boucle)',
      prices: {
        SIMPLE: 30,
        COMPLEX: 30
      },
      multiple: true,
      id: '12.bag-cure-37'
    }, {
      name: 'Autre pièce métallique (crochet / boucle) fourni par le client',
      prices: {
        SIMPLE: 20,
        COMPLEX: 20
      },
      multiple: true,
      id: '12.bag-cure-38'
    },
    // DEPRECATED
    {
      name: 'Déchirure : réparation avec pose d‘empiècement',
      prices: {
        SIMPLE: 60
      },
      multiple: true,
      id: '12.bag-cure-3',
      hidden: true
    }, {
      name: 'Déchirure : réparation avec changement de panneau (petit)',
      prices: {
        SIMPLE: 90
      },
      multiple: true,
      id: '12.bag-cure-4',
      hidden: true
    }, {
      name: 'Déchirure : réparation avec changement de panneau (moyen)',
      prices: {
        SIMPLE: 120
      },
      multiple: true,
      id: '12.bag-cure-5',
      hidden: true
    }, {
      name: 'Déchirure : réparation avec changement de panneau (grand)',
      prices: {
        SIMPLE: 150
      },
      multiple: true,
      id: '12.bag-cure-6',
      hidden: true
    }, {
      name: 'Déchirure : réparation avec changement de panneau (complex)',
      prices: {
        SIMPLE: 180
      },
      multiple: true,
      id: '12.bag-cure-7',
      hidden: true
    }, {
      name: 'Bandoulière / anse / poignée / biais - Changement simple (x1)',
      prices: {
        SIMPLE: 50
      },
      id: '12.bag-cure-11',
      hidden: true
    }, {
      name: 'Bandoulière / anse / poignée / biais - Changement standard (x1)',
      prices: {
        SIMPLE: 70
      },
      id: '12.bag-cure-12',
      hidden: true
    }, {
      name: 'Bandoulière / anse / poignée / biais - Changement complexe (x1)',
      prices: {
        SIMPLE: 100
      },
      id: '12.bag-cure-13',
      hidden: true
    }, {
      name: 'Renfort intérieur - Changement simple (x1 empiècement) ',
      prices: {
        SIMPLE: 30
      },
      id: '12.bag-cure-18',
      hidden: true
    }, {
      name: 'Renfort intérieur - Changement complexe (x1 empiècement) ',
      prices: {
        SIMPLE: 50
      },
      id: '12.bag-cure-19',
      hidden: true
    }, {
      name: 'Bandoulière / anse / poignée - Changement métallique (x1)',
      prices: {
        SIMPLE: 40
      },
      id: '12.bag-cure-20',
      hidden: true
    }]
  }, communLeatherGoodsFinish('bag')]
}, _objectSpread({
  name: 'Portefeuille & Pochette',
  slug: 'wallet',
  hasMostCommonCategory: false,
  types: [{
    slug: 'SIMPLE',
    name: 'Cuir'
  }, {
    slug: 'COMPLEX',
    name: 'Daim'
  }]
}, generateLeatherGoodsAccePrice('wallet')), _objectSpread({
  name: 'Ceinture',
  slug: 'belt',
  hasMostCommonCategory: false,
  types: [{
    slug: 'SIMPLE',
    name: 'Cuir'
  }, {
    slug: 'COMPLEX',
    name: 'Daim'
  }]
}, generateLeatherGoodsAccePrice('belt')), {
  name: 'Chaussures',
  slug: 'shoes',
  hasMostCommonCategory: false,
  types: [{
    slug: 'SIMPLE',
    name: 'Cuir'
  }, {
    slug: 'COMPLEX',
    name: 'Daim'
  }],
  categories: [{
    name: 'Prise en charge',
    slug: 'receiving',
    items: [{
      name: 'Prise en charge - Chaussures plates',
      prices: {
        SIMPLE: 0,
        COMPLEX: 0
      },
      id: '12.shoes-receiving-1'
    }, {
      name: 'Prise en charge - Chaussures à talon',
      prices: {
        SIMPLE: 0,
        COMPLEX: 0
      },
      id: '12.shoes-receiving-2'
    }, {
      name: 'Prise en charge - Sneakers',
      prices: {
        SIMPLE: 0,
        COMPLEX: 0
      },
      id: '12.shoes-receiving-3'
    }, {
      name: 'Prise en charge - Bottes / Bottines plates',
      prices: {
        SIMPLE: 0,
        COMPLEX: 0
      },
      id: '12.shoes-receiving-4'
    }, {
      name: 'Prise en charge - Bottes / Bottines à talon',
      prices: {
        SIMPLE: 0,
        COMPLEX: 0
      },
      id: '12.shoes-receiving-5'
    }]
  }, {
    name: 'Entretenir',
    slug: 'prevent',
    items: [{
      name: 'Entretien (nettoyage & cirage)',
      prices: {
        SIMPLE: 25,
        COMPLEX: 29
      },
      id: '12.shoes-prevent-1'
    }, {
      name: 'Entretien (nettoyage & cirage) - Bottes',
      prices: {
        SIMPLE: 35,
        COMPLEX: 39
      },
      id: '12.shoes-prevent-2'
    },
    // Same price textile, leather, suede
    {
      name: 'Entretien (nettoyage & cirage) - Sneakers',
      prices: {
        SIMPLE: 29,
        COMPLEX: 29
      },
      id: '12.shoes-prevent-3'
    }, {
      name: 'Entretien (nettoyage & cirage) - Supplément semelle',
      prices: {
        SIMPLE: 5,
        COMPLEX: 5
      },
      id: '12.shoes-prevent-14'
    }, {
      name: 'Cirage & Glaçage',
      prices: {
        SIMPLE: 55,
        COMPLEX: 55
      },
      id: '12.shoes-prevent-4'
    }, {
      name: 'Rénovation complète',
      prices: {
        SIMPLE: 55,
        COMPLEX: 59
      },
      id: '12.shoes-prevent-5'
    }, {
      name: 'Rénovation complète - Sneakers',
      prices: {
        SIMPLE: 55,
        COMPLEX: 55
      },
      id: '12.shoes-prevent-6'
    }, {
      name: 'Rénovation complète - Bottes',
      prices: {
        SIMPLE: 65,
        COMPLEX: 65
      },
      id: '12.shoes-prevent-7'
    }, {
      name: 'Mise en forme - Largeur',
      prices: {
        SIMPLE: 15,
        COMPLEX: 15
      },
      id: '12.shoes-prevent-8'
    }, {
      name: 'Mise en forme - Coup de pied',
      prices: {
        SIMPLE: 29,
        COMPLEX: 29
      },
      id: '12.shoes-prevent-9'
    }, {
      name: 'Mise en forme - Mollet (bottine ou botte)',
      prices: {
        SIMPLE: 29,
        COMPLEX: 29
      },
      id: '12.shoes-prevent-10'
    }, {
      name: 'Pose de patins (x2)',
      prices: {
        SIMPLE: 26,
        COMPLEX: 26
      },
      id: '12.shoes-prevent-11',
      repairBonus: 'SHOE_OVERSHOE'
    }, {
      name: 'Pose de fers (x2)',
      prices: {
        SIMPLE: 21,
        COMPLEX: 21
      },
      id: '12.shoes-prevent-12',
      repairBonus: 'SHOE_SEWING'
    }, {
      name: 'Protection complète - Patins & fers (x2)',
      prices: {
        SIMPLE: 45,
        COMPLEX: 45
      },
      id: '12.shoes-prevent-13',
      repairBonus: 'SHOE_OVERSHOE_AND_SEWING'
    }]
  }, {
    name: 'Réparer',
    slug: 'cure',
    items: [{
      name: 'Ressemelage - Collé Caoutchouc - Semelle complète',
      prices: {
        SIMPLE: 83,
        COMPLEX: 83
      },
      id: '12.shoes-cure-1',
      repairBonus: 'SHOE_RESOLE_RUBBER'
    }, {
      name: 'Ressemelage - Collé Caoutchouc - Demi semelle',
      prices: {
        SIMPLE: 78,
        COMPLEX: 78
      },
      id: '12.shoes-cure-24',
      repairBonus: 'SHOE_RESOLE_RUBBER'
    }, {
      name: 'Ressemelage - Collé Cuir - Semelle complète',
      prices: {
        SIMPLE: 110,
        COMPLEX: 110
      },
      id: '12.shoes-cure-2',
      repairBonus: 'SHOE_RESOLE_LEATHER'
    }, {
      name: 'Ressemelage - Collé Cuir - Demi semelle',
      prices: {
        SIMPLE: 85,
        COMPLEX: 85
      },
      id: '12.shoes-cure-25',
      repairBonus: 'SHOE_RESOLE_LEATHER'
    }, {
      name: 'Ressemelage - Sneakers',
      prices: {
        SIMPLE: 70,
        COMPLEX: 70
      },
      id: '12.shoes-cure-3',
      repairBonus: 'SHOE_RESOLE_RUBBER'
    }, {
      name: 'Ressemelage - Cousu rainette - Semelle complète',
      prices: {
        SIMPLE: 130,
        COMPLEX: 130
      },
      id: '12.shoes-cure-4',
      repairBonus: 'SHOE_RESOLE_LEATHER'
    }, {
      name: 'Ressemelage - Cousu rainette - Demi semelle',
      prices: {
        SIMPLE: 90,
        COMPLEX: 90
      },
      id: '12.shoes-cure-26',
      repairBonus: 'SHOE_RESOLE_LEATHER'
    }, {
      name: 'Ressemelage - Cousu sous gravure',
      prices: {
        SIMPLE: 175,
        COMPLEX: 175
      },
      id: '12.shoes-cure-5',
      repairBonus: 'SHOE_RESOLE_LEATHER'
    }, {
      name: 'Ressemelage - Birkenstock',
      prices: {
        SIMPLE: 54,
        COMPLEX: 54
      },
      id: '12.shoes-cure-6',
      repairBonus: 'SHOE_RESOLE_RUBBER'
    }, {
      name: 'Bonbout (changement) - Chaussures à talon plat - Caoutchouc',
      prices: {
        SIMPLE: 24,
        COMPLEX: 24
      },
      id: '12.shoes-cure-7',
      repairBonus: 'SHOE_CAP'
    }, {
      name: 'Bonbout (changement) - Chaussures à talon plat - Cuir + caoutchouc',
      prices: {
        SIMPLE: 29,
        COMPLEX: 29
      },
      id: '12.shoes-cure-8',
      repairBonus: 'SHOE_CAP'
    }, {
      name: 'Bonbout (changement) - Talons aiguille',
      prices: {
        SIMPLE: 15,
        COMPLEX: 15
      },
      id: '12.shoes-cure-9',
      repairBonus: 'SHOE_CAP'
    }, {
      name: 'Talon complet (changement) - Chaussures plates',
      prices: {
        SIMPLE: 65,
        COMPLEX: 65
      },
      id: '12.shoes-cure-10',
      repairBonus: 'SHOE_SEWING'
    }, {
      name: 'Enveloppe talon (changement) - Chaussures à talons',
      prices: {
        SIMPLE: 55,
        COMPLEX: 55
      },
      id: '12.shoes-cure-11',
      repairBonus: 'SHOE_SEWING'
    }, {
      name: 'Redresse talon - Chaussures plates',
      prices: {
        SIMPLE: 17,
        COMPLEX: 17
      },
      id: '12.shoes-cure-12',
      repairBonus: 'SHOE_SEWING'
    }, {
      name: 'Semelle intérieure - Demi',
      prices: {
        SIMPLE: 17,
        COMPLEX: 17
      },
      id: '12.shoes-cure-13'
    }, {
      name: 'Semelle intérieure - Complète',
      prices: {
        SIMPLE: 22,
        COMPLEX: 22
      },
      id: '12.shoes-cure-14'
    }, {
      name: 'Glissoirs (changement)',
      prices: {
        SIMPLE: 35,
        COMPLEX: 35
      },
      id: '12.shoes-cure-15',
      repairBonus: 'SHOE_SEWING'
    }, {
      name: 'Glissoirs boots (changement)',
      prices: {
        SIMPLE: 50,
        COMPLEX: 50
      },
      id: '12.shoes-cure-16',
      repairBonus: 'SHOE_SEWING'
    }, {
      name: 'Zip - Changement (x1)',
      prices: {
        SIMPLE: 45,
        COMPLEX: 45
      },
      multiple: true,
      id: '12.shoes-cure-17',
      repairBonus: 'SHOE_ZIP_SMALL'
    }, {
      name: 'Zip de bottes - Changement (x1)',
      prices: {
        SIMPLE: 55,
        COMPLEX: 55
      },
      multiple: true,
      id: '12.shoes-cure-18',
      repairBonus: 'SHOE_ZIP_BIG'
    }, {
      name: 'Boutons pression / œillets / rivets (x1)',
      prices: {
        SIMPLE: 11,
        COMPLEX: 11
      },
      multiple: true,
      id: '12.shoes-cure-19'
    }, {
      name: 'Boucle - Changement (x1)',
      prices: {
        SIMPLE: 19,
        COMPLEX: 19
      },
      multiple: true,
      id: '12.shoes-cure-20',
      repairBonus: 'SHOE_SEWING'
    }, {
      name: 'Élastique / scratch - Changement (x1)',
      prices: {
        SIMPLE: 19,
        COMPLEX: 19
      },
      multiple: true,
      id: '12.shoes-cure-21',
      repairBonus: 'SHOE_SEWING'
    }, {
      name: 'Boucle avec élastique - Changement (x1)',
      prices: {
        SIMPLE: 35,
        COMPLEX: 35
      },
      multiple: true,
      id: '12.shoes-cure-22',
      repairBonus: 'SHOE_SEWING'
    }, {
      name: 'Recollage semelle',
      prices: {
        SIMPLE: 30,
        COMPLEX: 30
      },
      multiple: true,
      id: '12.shoes-cure-23',
      repairBonus: 'SHOE_SEWING'
    }, {
      name: 'Trou (rustine intérieur',
      prices: {
        SIMPLE: 18,
        COMPLEX: 18
      },
      multiple: true,
      id: '12.shoes-cure-27',
      repairBonus: 'SHOE_SEWING'
    }]
  }, {
    name: 'Finition',
    slug: 'finish',
    items: [{
      name: 'Couture / Finition supplémentaire - Simple',
      prices: {
        SIMPLE: 5,
        COMPLEX: 5
      },
      id: '12.shoes-finish-1'
    }, {
      name: 'Couture / Finition supplémentaire - Standard',
      prices: {
        SIMPLE: 10,
        COMPLEX: 10
      },
      id: '12.shoes-finish-2'
    }, {
      name: 'Couture / Finition supplémentaire - Complexe',
      prices: {
        SIMPLE: 20,
        COMPLEX: 20
      },
      id: '12.shoes-finish-3'
    }]
  }]
}];
var _default = exports["default"] = rawLeatherGoodsPricing;